export default __webpack_public_path__ + "static/media/0003.99e9618b.png";